// src/components/CookieBanner.jsx
import { useState, useEffect } from 'react';
import './CookieBanner.css';

// cookie helpers (with explicit path)
function setCookie(name, value, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/`;
}
function getCookie(name) {
  return document.cookie.split('; ').reduce((r, c) => {
    const [k, v] = c.split('=');
    return k === name ? decodeURIComponent(v) : r;
  }, '');
}
function deleteCookie(name) {
  // expire immediately
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

export default function CookieBanner() {
  const [consent, setConsent] = useState(getCookie('site_consent'));

  useEffect(() => {
    if (consent === 'all') {
      // …init analytics, ads, etc.
    }
    if (consent === 'none') {
      deleteCookie('_ga');
      deleteCookie('_gid');
    }
    // 'necessary' → do nothing extra
  }, [consent]);

  // if we already have consent, don’t render
  if (consent) return null;

  return (
    <div className="cookieBanner">
      <span>
        We use cookies to enhance your experience. Read our{' '}
        <a
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>.
      </span>
      <div className="buttonGroup">
        <button
          className="btn-all"
          onClick={() => {
            setCookie('site_consent', 'all');
            setConsent('all');
          }}
        >
          Accept all
        </button>
        <button
          className="btn-essential"
          onClick={() => {
            setCookie('site_consent', 'necessary');
            setConsent('necessary');
          }}
        >
          Essential only
        </button>
        <button
          className="btn-none"
          onClick={() => {
            setCookie('site_consent', 'none');
            setConsent('none');
          }}
        >
          Reject all
        </button>
      </div>
    </div>
  );
}
